<div>
  <app-generic-form title="Registrazione">
    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" form-content>

      <button type="button" class="btn btn-warning btn-sm w-100 mb-3 d-inline-flex align-items-center justify-content-center" routerLink="/login">
        <i class="bi bi-box-arrow-in-right me-1" aria-hidden="true"></i>Sei già registrato?
      </button>

      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched"
          placeholder="Inserisci la tua mail">
        @if (signupForm.get('email')?.invalid && signupForm.get('email')?.touched) {
          <div class="invalid-feedback">
            Inserisci un'email valida.
          </div>
        }
      </div>

      <div class="mb-3">
        <label for="username" class="form-label">Username</label>
        <input
          id="username"
          type="text"
          formControlName="userName"
          class="form-control"
          [class.is-invalid]="signupForm.get('userName')?.invalid && signupForm.get('userName')?.touched"
          placeholder="Inserisci il tuo username">
        @if (signupForm.get('userName')?.invalid && signupForm.get('userName')?.touched) {
          <div class="invalid-feedback">
            L'username è obbligatorio.
          </div>
        }
      </div>

      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="signupForm.get('password')?.invalid && signupForm.get('password')?.touched"
          placeholder="Password">
        @if (signupForm.get('password')?.invalid && signupForm.get('password')?.touched) {
          <div class="invalid-feedback">
            La password deve essere di almeno 6 caratteri.
          </div>
        }
      </div>

      <button
        type="submit"
        [disabled]="isLoading() || signupForm.invalid"
        class="btn btn-primary w-100 mt-4 d-inline-flex align-items-center justify-content-center">
        <i class="bi" [class.bi-hourglass-split]="isLoading()" [class.bi-person-plus-fill]="!isLoading()" aria-hidden="true"></i>
        <span class="ms-1">{{ isLoading() ? 'Caricamento...' : 'Registrazione' }}</span>
      </button>

    </form>
  </app-generic-form>
</div>
